import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENV, IEnvironment } from '@shabic/models';

@Injectable({ providedIn: 'root' })
export class SupplierEdiReportService {
  private readonly url = '/api/supplier-order-daily-reports';

  constructor(private http: HttpClient, @Inject(ENV) private env: IEnvironment) {}

  getSupplierOrderDailyReports(params: any): Observable<any> {
    return this.http.get<any>(this.url, { params }).pipe(
      map(response => response),
      catchError(response => of({ content: [], totalPages: 1, totalElements: 0, error: response }))
    );
  }
} 